module.exports = __webpack_public_path__ + "static/media/bl3.9bd761c6.jpg";